export default "__VITE_ASSET__DmgBkvoV__"